module.exports = __webpack_public_path__ + "img/upfile.76c1a32b.svg";